import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  RdsProgressSpinnerComponent,
  RdsSwitchComponent,
} from '@rds/angular-components';
import { RdsPaginatorPageEvent } from '@rds/core';

import {
  BookingStatsComponent,
  BookingsTableComponent,
  ChartDataService,
  GroupedBarChartComponent,
  PieChartComponent,
  ViewportService,
} from '@bookly/shared';

@Component({
  selector: 'bus-charts',
  imports: [
    GroupedBarChartComponent,
    PieChartComponent,
    RdsProgressSpinnerComponent,
    BookingStatsComponent,
    FormsModule,
    BookingsTableComponent,
    RdsSwitchComponent,
  ],
  templateUrl: './charts.component.html',
  styleUrl: './charts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartsComponent implements OnInit {
  readonly #chartService = inject(ChartDataService);
  readonly #viewport = inject(ViewportService);
  protected readonly countPerMonthRT = this.#chartService.countPerMonthRT;
  protected readonly averagePerWeekday = this.#chartService.averagePerWeekday;
  protected readonly averagePeoplePerRoomType =
    this.#chartService.averagePeoplePerRoomType;
  protected readonly countPerStatus = this.#chartService.countPerStatus;
  protected readonly isLoading = this.#chartService.isDataLoading;
  protected readonly bookingsData = this.#chartService.chartTableRows;
  protected readonly tablePaginationState =
    this.#chartService.tablePaginationState;
  // Seeded from the viewport, then owned by the user via the ngModel switches.
  protected showLegend = !this.#viewport.isMobile();
  protected showValues = !this.#viewport.isMobile();

  ngOnInit(): void {
    this.#chartService.loadChartData().subscribe();
  }

  protected onPageChange(event: RdsPaginatorPageEvent) {
    this.#chartService
      .loadChartTableRows(event.pageIndex, event.pageSize)
      .subscribe();
  }

  protected exportToCSV() {
    this.#chartService.exportChartDataCsv().subscribe(response => {
      if (!response.body) {
        return;
      }
      const contentDisposition =
        response.headers.get('Content-Disposition') ?? '';
      const filenameMatch = /filename=([^;]+)/i.exec(contentDisposition);
      const filename =
        filenameMatch?.[1]?.replaceAll('"', '') ?? 'bookings-data.csv';
      const blobUrl = URL.createObjectURL(response.body);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = filename;
      anchor.click();
      URL.revokeObjectURL(blobUrl);
    });
  }
}
